import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export default function QuickSearch({ value, onChange, handleSubmit }) {
  const hasValue = Boolean(value?.trim());

  const onSearch = () => {
    if (!hasValue) return;
    handleSubmit();
  };

  return (
    <TextField
      fullWidth
      size="small"
      placeholder="Quick Search"
      sx={{ mt: 1 }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onSearch();
        }
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {/* Clear icon – only when text exists */}
            {hasValue && (
              <IconButton
                size="small"
                onClick={() => onChange("")}
                edge="end"
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            )}

            {/* Search icon – always visible, disabled when empty */}
            <IconButton
              size="small"
              onClick={onSearch}
              edge="end"
              disabled={!hasValue}
            >
              <SearchIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
